import gql from 'graphql-tag';

import lessonFragment from '~/shared/graphql-queries/lessons/lesson-fragment';

export default gql`
  query findByIdLessonQuery($_id: MongoID!) {
    findByIdLessonQuery(_id: $_id) {
      ...LessonFragment
    }
  }
  ${lessonFragment}
`;
